import z from "zod";
import { PublicProjectSchema } from "./entity";

export const FavoriteSchemas = {
  list: {
    response: z.object({
      projectIds: z.array(z.uuidv7()),
      projects: z.array(PublicProjectSchema),
    }),
  },
  toggle: {
    request: z.object({ projectId: z.uuidv7() }),
    response: z.object({ projectId: z.uuidv7(), isFavorite: z.boolean() }),
  },
  remove: {
    request: z.object({ projectId: z.uuidv7() }),
  },
};

export type FavoriteList = z.infer<typeof FavoriteSchemas.list.response>;
export type ToggleFavorite = z.infer<typeof FavoriteSchemas.toggle.request>;
